export default {
  priv: 'pr_reference',
  overviewTitle: 'Toezichters',
  detailTitle: 'Toezichter',
  deleteTitle: 'deze toezichter',
  url: '/references/supervisors',
  apiUrl: '/supervisors/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'supervisors',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  newRecord: {
    is_active: true
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/supervisors/{id}',
      width: '40%'
    },
    {
      text: 'Email',
      value: 'email_address',
      width: '50%'
    }
  ]
};
